import React, {useEffect, useState} from 'react';
import BasicLayout from '../../../../layout/basicLayout';
import {SCHOOL} from '../../../../contant';
import Bread from '../../../../components/bread';
import Header from '../../../../comp-mobile/header';
import styles from './index.less';

const CooperateDetail = (props) => {
    const [school,setSchool] = useState({})
    useEffect(()=>{
        const {query} = props?.location
        const newTitle = query?.title ? query?.title : localStorage.getItem('schoolTitle')
        localStorage.setItem('schoolTitle', newTitle)
        const school = SCHOOL.find(ele=>ele.title === newTitle)
        setSchool(school)

        setTimeout(() => {
            const caseDetails = document.getElementById('caseDetails');
            if (caseDetails) {
                caseDetails.scrollIntoView({behavior: "smooth"})
            }
        }, 100)

        return () => {
            localStorage.removeItem('schoolTitle');
        }
    }, [])
    return <BasicLayout>
        <Header fixed/>
        <div className={styles.caseDetails} id="caseDetails">
            <div style={{height:'60px'}}/>
            <Bread breads = {[{name:'首页',href: '#/home'},{name:'商业合作',href:'#/cooperate'},{name:'案例详情'}]}/>
            {school.content}
        </div>
    </BasicLayout>;
};
export default CooperateDetail;
